import React, { forwardRef } from 'react';

const ImageUploadInput = forwardRef(function ImageUploadInput(
  { onChange, multiple = false, accept, ...props },
  ref
) {
  const acc =
    accept ||
    'image/png,image/jpeg,image/webp,image/heic,image/heif,video/mp4,video/quicktime,video/webm,video/3gpp';
  return (
    <input
      type="file"
      {...props}
      multiple={multiple}
      accept={acc}
      onChange={onChange}
      ref={ref}
    />
  );
});

export default ImageUploadInput;

